(function($) {
  // activate first element
  $(".tab-content-top img:first-of-type").addClass("active");
  $(".tab-content-bottom > div:first-of-type").addClass("active");
  $(".tab-nav li:first-of-type").addClass("active");

  // click on tab
  $('.tab-nav a').click(function(event) {
    event.preventDefault();

    // remove current active class
    $(".tab-content-top img").removeClass("active");
    $(".tab-content-bottom > div").removeClass("active");
    $(".tab-nav li").removeClass("active");

    //get id
    var idLink = $(this).attr('href');
    var id = idLink.substring(1, idLink.length);

    //add active class to current elment
    $(this).parent().addClass('active');
    $('img[data-id="' + id + '"]').addClass('active');
    $(idLink).addClass('active');
  });

})(jQuery);
